module.exports = __webpack_public_path__ + "static/media/ccflogogray.7cd8c494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/ccflogogray.svg
// module id = 668
// module chunks = 0